export default {
	name: 'shellydoornb',
	friendly_name: 'Door NB',
	family: 'sensor',
	isPM: false,
	is_nb: true,
	modes: ['sensor'],
	settings: [{ title: 'not_ready' }],
};
